import { Helmet } from 'react-helmet';
import { Box, Container, Grid } from '@material-ui/core';
import LatestOrders from '../components/dashboard/LatestOrders';
import ApiManagement from '../components/dashboard/ApiManagement';
import PlanStatus from '../components/dashboard/PlanStatus';
import Pricing from './Pricing';

const Dashboard = () => (
	<>
		<Helmet>
			<title>Dashboard | Parcels API</title>
		</Helmet>
		<Box
			sx={{
				backgroundColor: 'background.default',
				minHeight: '100%',
				py: 3,
			}}
		>
			<Container maxWidth={false}>
				<Grid container spacing={3}>
					<Grid item lg={12} md={12} xl={12} xs={12}>
						<PlanStatus />
					</Grid>
					<Grid item lg={12} md={12} xl={12} xs={12}>
						<ApiManagement />
					</Grid>
{/*					<Grid item lg={12} md={12} xl={12} xs={12}>
						<LatestOrders />
					</Grid>
*/}				</Grid>
			</Container>
		</Box>
	</>
);

export default Dashboard;
